import { ReactElement } from "react";
import { DefaultTopNavLayout } from ".";
import DefaultLayout from "./default-layout/DefaultLayout";
import DashboardNav from "./dashboard-navbar/DashboardNavbar";

export const useDefaultTopLayout = (page: ReactElement) => {
    return <DefaultTopNavLayout>{page}</DefaultTopNavLayout>;
};

export const useHomePageDefaultLayout = (page: ReactElement) => {
    return <DefaultLayout navContent={<DashboardNav />}>{page}</DefaultLayout>;
};
